module.exports = new __parcel__URL__("fsharp.1bf7666b.png").toString();